import "./DefaultPreview.scss";

import { Text } from "@fluentui/react-northstar";

import Logo from "./authoring_empty_state.svg";

type Props = {};

export const DefaultPreview: React.FC<Props> = _ => {
  return (
    <div className="default-preview">
      <img src={Logo} height={64} alt="Polly" />
      <div style={{ marginTop: "10px" }}>
        <Text weight="bold" size="medium">
          Ready to create a polly
        </Text>
        <br />
        <Text size="small" weight="semibold" style={{ color: "#398AF6" }}>
          Try Creating a Question
        </Text>
      </div>
    </div>
  );
};
